module.exports = __webpack_public_path__ + "img/mockup.7c8f1549.png";